import { useEffect, useRef } from 'react';

type Props = {
  trackEvent: (data: Record<string, string | number | boolean>) => void;
  fieldName: string;
  shouldTrack: boolean;
  action: 'field_modified' | 'field_error';
};

export const useNarrativeTrackingFieldAction = ({
  trackEvent,
  fieldName,
  shouldTrack,
  action,
}: Props) => {
  const trackedRef = useRef(false);

  useEffect(() => {
    if (!shouldTrack || trackedRef.current || !fieldName) return;

    trackEvent({
      action,
      field: fieldName,
    });
    trackedRef.current = true;
  }, [shouldTrack, trackEvent, fieldName, action]);
};
